export enum BelegeTableColumns {
  Checkbox = 'checkbox',
  Status = 'status',
  HochgeladenAm = 'hochgeladenAm',
  Belegtyp = 'belegtyp',
  EinAusgang = 'einAusgang',
  Kommentar = 'kommentar',
  KundeLieferant = 'kundeLieferant',
  Belegdatum = 'belegdatum',
  Betrag = 'betrag',
  Seitenzahl = 'seitenzahl',
  KontumsatzZugeordnet = 'kontoumsatzZugeordnet',
  Zahlungsart = 'zahlungsart',
  Actions = 'actions',
}
